import React, { useState, memo } from 'react';
import { CheckCircle2, ChevronDown, ChevronUp } from 'lucide-react';
const tomos = [{
  icon: '🔵',
  title: 'Tomo 1 — Base Clara de Farmacología',
  subtitle: 'Entendé lo esencial sin confusión',
  accent: 'border-l-blue-500',
  items: ['Conceptos fundamentales claros', 'Cómo funciona un fármaco en el cuerpo', 'Clasificación básica sin vueltas', 'Vías de administración explicadas', 'Base sólida para no dudar']
}, {
  icon: '🔴',
  title: 'Tomo 2 — Memorización Inteligente de Fármacos',
  subtitle: 'Recordá lo importante sin esfuerzo',
  accent: 'border-l-red-500',
  items: ['Técnicas reales de memorización', 'Asociación de fármacos clave', 'Métodos prácticos para recordar', 'Reducción de sobrecarga mental', 'Aplicación rápida en estudio y práctica']
}, {
  icon: '🟢',
  title: 'Tomo 3 — Fármacos Clave que Tenés que Saber',
  subtitle: 'Dominá lo que realmente importa',
  accent: 'border-l-green-500',
  items: ['Medicamentos más usados', 'Indicaciones principales', 'Dosis habituales', 'Efectos importantes', 'Lo esencial para la práctica real']
}, {
  icon: '🟠',
  title: 'Tomo 4 — Aplicación Clínica Real',
  subtitle: 'Llevá la teoría a la práctica',
  accent: 'border-l-orange-500',
  items: ['Cómo actuar en situaciones reales', 'Toma de decisiones con fármacos', 'Evaluación del paciente', 'Aplicación segura en guardia', 'Casos clínicos prácticos']
}, {
  icon: '🟣',
  title: 'Tomo 5 — Errores Críticos y Cómo Evitarlos',
  subtitle: 'Reduclí riesgos al máximo',
  accent: 'border-l-purple-500',
  items: ['Errores más comunes', 'Qué NO hacer al medicar', 'Riesgos reales', 'Prevención de fallas', 'Seguridad en cada paso']
}, {
  icon: '🟡',
  title: 'Tomo 6 — Automatización y Respuesta Rápida',
  subtitle: 'Actuá sin bloquearte',
  accent: 'border-l-yellow-400',
  items: ['Protocolos mentales rápidos', 'Respuestas automáticas seguras', 'Flujo de acción claro', 'Agilidad en guardia', 'Seguridad sin pensar de más']
}];
const features = ['guías paso a paso', 'herramientas prácticas', 'ejemplos reales', 'aplicación inmediata', 'uso en guardia'];
export function TomosSection() {
  const [expandedIdx, setExpandedIdx] = useState<number | null>(null);
  return <section className="py-5 px-5 bg-brand-navy" data-id="element-297">
      <div className="max-w-xl mx-auto" data-id="element-298">
        <h2 className="text-2xl md:text-3xl font-bold text-center text-white mb-3" data-id="element-299">
          📚 LO QUE RECIBÍS
        </h2>
        <p className="text-center text-gray-400 text-sm mb-8" data-id="element-300">
          6 tomos completos listos para usar
        </p>

        <div className="space-y-3 mb-10" data-id="element-301">
          {tomos.map((tomo, idx) => {
          const isOpen = expandedIdx === idx;
          return <div key={idx} className={`bg-brand-blue-dark/40 border border-white/5 border-l-4 ${tomo.accent} rounded-lg overflow-hidden transition-all`} data-id="element-302">
                <button onClick={() => setExpandedIdx(isOpen ? null : idx)} className="w-full p-4 flex items-start gap-3 text-left" data-id="element-303">
                  <span className="text-2xl flex-shrink-0" data-id="element-304">{tomo.icon}</span>
                  <div className="flex-grow min-w-0" data-id="element-305">
                    <h3 className="text-sm font-bold text-white mb-0.5" data-id="element-306">
                      {tomo.title}
                    </h3>
                    <p className="text-xs text-gray-500" data-id="element-307">{tomo.subtitle}</p>
                  </div>
                  {isOpen ? <ChevronUp size={18} className="text-brand-yellow flex-shrink-0 mt-1" data-id="element-308" /> : <ChevronDown size={18} className="text-gray-600 flex-shrink-0 mt-1" data-id="element-309" />}
                </button>
                {isOpen && <div className="px-4 pb-4 pl-12" data-id="element-310">
                    <div className="space-y-2" data-id="element-311">
                      {tomo.items.map((item, i) => <div key={i} className="flex items-center gap-2" data-id="element-312">
                          <CheckCircle2 className="text-green-500 flex-shrink-0" size={14} data-id="element-313" />
                          <span className="text-xs text-gray-400" data-id="element-314">{item}</span>
                        </div>)}
                    </div>
                  </div>}
              </div>;
        })}
        </div>

        <div className="bg-gray-900 border border-gray-800 rounded-xl p-6 mb-10" data-id="element-315">
          <h3 className="text-base font-bold text-center mb-4 text-[#FFD000]" data-id="element-316">
            ✨ Cada tomo incluye:
          </h3>
          <div className="space-y-3" data-id="element-317">
            {features.map((feature, idx) => <div key={idx} className="flex items-center gap-3" data-id="element-318">
                <CheckCircle2 className="text-green-500 flex-shrink-0" size={18} data-id="element-319" />
                <span className="text-sm text-gray-300 font-medium" data-id="element-320">
                  {feature}
                </span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}